var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.1719L5.67301 15.7101C5.58509 15.5981 5.49809 15.4853 5.41201 15.3719C4.33124 13.9482 3.74739 12.2093 3.75001 10.4219C3.75001 8.23384 4.6192 6.13542 6.16638 4.58824C7.71355 3.04107 9.81197 2.17188 12 2.17188C14.188 2.17188 16.2865 3.04107 17.8336 4.58824C19.3808 6.13542 20.25 8.23384 20.25 10.4219C20.2526 12.2085 19.669 13.9466 18.5888 15.3696L18.588 15.3719C18.588 15.3719 18.363 15.6674 18.3293 15.7071L12 23.1719ZM6.60901 14.4681C6.61051 14.4681 6.78451 14.6991 6.82426 14.7486L12 20.8529L17.1825 14.7404C17.2155 14.6991 17.391 14.4666 17.3918 14.4659C18.2746 13.3027 18.7517 11.8821 18.75 10.4219C18.75 8.63166 18.0388 6.91477 16.773 5.6489C15.5071 4.38303 13.7902 3.67188 12 3.67188C10.2098 3.67188 8.49291 4.38303 7.22704 5.6489C5.96117 6.91477 5.25001 8.63166 5.25001 10.4219C5.24844 11.8831 5.72609 13.3044 6.60976 14.4681H6.60901Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.1719H14.25V8.17188H9.75V14.1719H8.25V8.17188C8.2504 7.77417 8.40856 7.39287 8.68978 7.11165C8.971 6.83044 9.3523 6.67227 9.75 6.67188H14.25C14.6477 6.67227 15.029 6.83044 15.3102 7.11165C15.5914 7.39287 15.7496 7.77417 15.75 8.17188V14.1719Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.6719H12.75V14.1719H11.25V12.6719ZM11.25 9.67188H12.75V11.1719H11.25V9.67188Z",
    fill: "#2F2F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbout);
export default __webpack_public_path__ + "static/media/icon-about.56b9eaf297c13d036cd5b25d9bea896d.svg";
export { ForwardRef as ReactComponent };